'use client'

import React from 'react'
import Link from 'next/link'
import type { TopicFragment } from '../../../.graphql/generated-types'

export const defaultBackgroundColour = 'bg-blog-oceany-blue-300'

export const backgroundColors: Record<string, string> = {
  'Oceany Blue': defaultBackgroundColour,
  'Grapey Green': 'bg-blog-grapey-green-300',
  'Juicy Orange': 'bg-blog-juicy-orange-300',
  'Purply Pink': 'bg-blog-purply-pink-300',
}

export interface ComposeComponentTopicProps {
  data: TopicFragment
}

export function ComposeComponentTopic({ data }: ComposeComponentTopicProps) {
  if (data.name && data.slug && data.background) {
    const {
      name,
      slug,
      background: { colour: backgroundColour },
    } = data
    const bgColorClassName: string =
      backgroundColors[backgroundColour ?? ''] ?? defaultBackgroundColour
    const href = `/topics/${slug}`

    return (
      <>
        <Link
          style={{
            backgroundImage: `url(${data.background.image?.url ?? ''})`,
          }}
          href={href}
          className={`flex items-center justify-center rounded ${bgColorClassName} bg-[length:47rem] bg-bottom bg-repeat transition-all duration-300 hover:bg-[length:70rem] hover:bg-no-repeat hover:drop-shadow-[2px_2px_8px_rgba(0,0,0,0.16)] hover:ease-out`}
        >
          <div className="p-6 text-center text-white">{name}</div>
        </Link>
      </>
    )
  }
  return null
}
